import Vue from 'vue'
import Agent from '@zhenguo/jssdk/agent'
import { isNodeProd } from '@zhenguo/jssdk/base/env'

export default {
  install(app: typeof Vue) {
    if (!isNodeProd()) {
      console.log(Agent)
    }
    app.prototype.$agent = Agent
  },
}
